import gql from 'graphql-tag'
import { BLOCK_REQUEST_TIME } from '../constants'

export const SUBGRAPH_HEALTH = gql`
  query health {
    indexingStatusForCurrentVersion(subgraphName: "energi/energiswap") {
      chains {
        chainHeadBlock {
          number
        }
        latestBlock {
          number
        }
      }
    }
  }
`

export const GET_BLOCK = gql`
  query blocks($timestampFrom: String!, $timestampTo: String!) {
    blocks(
      first: 1
      orderBy: timestamp
      orderDirection: asc
      where: { timestamp_gt: $timestampFrom, timestamp_lt: $timestampTo }
    ) {
      number
      timestamp
    }
  }
`

export const GET_BLOCKS = (timestamps) => {
  let queryString = 'query blocks {'
  queryString += timestamps.map((timestamp) => {
    return `t${timestamp}:blocks(first: 1, orderBy: timestamp, orderDirection: desc, where: { timestamp_gt: "${timestamp}", timestamp_lt: "${timestamp + BLOCK_REQUEST_TIME
      }" }) {
      number
    }`
  })
  queryString += '}'
  return gql(queryString)
}

export const PRICES_BY_BLOCK = (tokenAddress, blocks) => {
  let queryString = 'query blocks {'
  queryString += blocks.map(
    (block) => `
      t${block.timestamp}:token(id:"${tokenAddress}", block: { number: ${block.number} }) {
        derivedNRG
      }
    `
  )
  queryString += ','
  queryString += blocks.map(
    (block) => `
      b${block.timestamp}: bundle(id:"1", block: { number: ${block.number} }) {
        nrgUsdPrice
      }
    `
  )

  queryString += '}'
  return gql(queryString)
}

export const TOP_LPS_PER_PAIRS = gql`
  query lps($pair: Bytes!) {
    liquidityPositions(where: { pair: $pair }, orderBy: liquidityTokenBalance, orderDirection: desc, first: 10) {
      user {
        id
      }
      pair {
        id
      }
      liquidityTokenBalance
    }
  }
`

export const HOURLY_PAIR_RATES = (pairAddress, blocks) => {
  let queryString = 'query blocks {'
  queryString += blocks.map(
    (block) => `
      t${block.timestamp}: pair(id:"${pairAddress}", block: { number: ${block.number} }) {
        token0Price
        token1Price
      }
    `
  )

  queryString += '}'
  return gql(queryString)
}

export const SHARE_VALUE = (pairAddress, blocks) => {
  let queryString = 'query blocks {'
  queryString += blocks.map(
    (block) => `
      t${block.timestamp}:pair(id:"${pairAddress}", block: { number: ${block.number} }) {
        reserve0
        reserve1
        reserveUSD
        totalSupply
        token0{
          derivedNRG
        }
        token1{
          derivedNRG
        }
      }
    `
  )
  queryString += ','
  queryString += blocks.map(
    (block) => `
      b${block.timestamp}: bundle(id:"1", block: { number: ${block.number} }) {
        nrgUsdPrice
      }
    `
  )

  queryString += '}'
  return gql(queryString)
}

export const NRG_PRICE = (block) => {
  const queryString = block
    ? `
    query bundle {
      bundle(id: "1", block: {number: ${block}}) {
        nrgUsdPrice
      }
    }
  `
    : `
    query bundle {
      bundle(id: "1") {
        nrgUsdPrice
      }
    }
  `
  return gql(queryString)
}

export const USER_MINTS_BUNRS_PER_PAIR = gql`
  query events($user: Bytes!, $pair: Bytes!) {
    mints(where: { to: $user, pair: $pair }) {
      amountUSD
      amount0
      amount1
      timestamp
      pair {
        token0 {
          id
        }
        token1 {
          id
        }
      }
    }
    burns(where: { sender: $user, pair: $pair }) {
      amountUSD
      amount0
      amount1
      timestamp
      pair {
        token0 {
          id
        }
        token1 {
          id
        }
      }
    }
  }
`

export const USER_HISTORY = gql`
  query snapshots($user: Bytes!, $skip: Int!) {
    liquidityPositionSnapshots(first: 1000, skip: $skip, where: { user: $user }) {
      timestamp
      reserveUSD
      liquidityTokenBalance
      liquidityTokenTotalSupply
      reserve0
      reserve1
      token0PriceUSD
      token1PriceUSD
      pair {
        id
        reserve0
        reserve1
        reserveUSD
        token0 {
          id
        }
        token1 {
          id
        }
      }
    }
  }
`

export const USER_POSITIONS = gql`
  query liquidityPositions($user: Bytes!) {
    liquidityPositions(first: 1000, where: { user: $user }) {
      pair {
        id
        reserve0
        reserve1
        reserveUSD
        token0 {
          id
          symbol
          derivedNRG
        }
        token1 {
          id
          symbol
          derivedNRG
        }
        totalSupply
      }
      liquidityTokenBalance
    }
  }
`

export const USER_TRANSACTIONS = gql`
  query transactions(
    $user: Bytes!
    $first: Int!
    $windowStart: String!
    $windowEnd: String!
    $orderDirection: OrderDirection!
  ) {
    mints(
      first: $first
      orderBy: timestamp
      orderDirection: $orderDirection
      where: { to: $user, timestamp_gte: $windowStart, timestamp_lt: $windowEnd }
    ) {
      id
      transaction {
        id
        timestamp
      }
      pair {
        id
        token0 {
          id
          symbol
        }
        token1 {
          id
          symbol
        }
      }
      to
      sender
      liquidity
      amount0
      amount1
      amountUSD
    }
    burns(
      first: $first
      orderBy: timestamp
      orderDirection: $orderDirection
      where: { sender: $user, timestamp_gte: $windowStart, timestamp_lt: $windowEnd }
    ) {
      id
      transaction {
        id
        timestamp
      }
      pair {
        id
        token0 {
          id
          symbol
        }
        token1 {
          id
          symbol
        }
      }
      sender
      to
      liquidity
      amount0
      amount1
      amountUSD
    }
    swaps(
      first: $first
      orderBy: timestamp
      orderDirection: $orderDirection
      where: { sender: $user, timestamp_gte: $windowStart, timestamp_lt: $windowEnd }
    ) {
      id
      transaction {
        id
        timestamp
      }
      pair {
        token0 {
          id
          symbol
        }
        token1 {
          id
          symbol
        }
      }
      amount0In
      amount0Out
      amount1In
      amount1Out
      amountUSD
      to
      sender
    }
  }
`

// Referral program removed
// export const REFEREES_DATA = gql`
//   query referees($first: Int!, $skip: Int!) {
//     referees(first: $first, skip: $skip, orderBy: timestamp, orderDirection: desc) {
//       id
//       totalCommissionsPaidToReferrer_1_USD
//       totalCommissionsPaidToReferrer_2_USD
//       totalCommissionsPaidToReferrer_3_USD
//       totalValueSwappedUSD
//       totalProtocolFeesPaidUSD
//       totalTradingFeesPaidUSD
//       totalTradingFeesPrecision
//       txCount
//       pairs(first: 1000) {
//         id
//         referee {
//           id
//         }
//         pair {
//           id
//           token0 {
//             id
//             symbol
//           }
//           token1 {
//             id
//             symbol
//           }
//         }
//         totalCommissionsPaidToReferrer_1
//         totalCommissionsPaidToReferrer_1_USD
//         totalCommissionsPaidToReferrer_2
//         totalCommissionsPaidToReferrer_2_USD
//         totalCommissionsPaidToReferrer_3
//         totalCommissionsPaidToReferrer_3_USD
//       }
//     }
//   }
// `

// export const REFERRER_REWARDS = gql`
//   query referrers($first: Int!, $skip: Int!) {
//     referrers(first: $first, skip: $skip, orderBy: timestamp, orderDirection: desc) {
//       id
//       totalCommissionsEarnedFromReferees_1_USD
//       totalCommissionsEarnedFromReferees_2_USD
//       totalCommissionsEarnedFromReferees_3_USD
//       dailyReferrerStatistic(first: 1000, orderBy: date, orderDirection: desc) {
//         id
//         date
//         commissionsEarnedFromReferees_1_USD
//         commissionsEarnedFromReferees_2_USD
//         commissionsEarnedFromReferees_3_USD
//         newRefereeSwaps
//       }
//     }
//   }
// `

// export const USER_REFERRALS = gql`
//   query referrers($first: Int!, $skip: Int!) {
//     referrers(first: $first, skip: $skip, orderBy: timestamp, orderDirection: asc) {
//       id
//       referees_1
//       referees_2
//       referees_3
//       timestamp
//       chartsData(first: 1000, orderBy: date, orderDirection: asc) {
//         id
//         date
//         referees_1_count
//         referees_2_count
//         referees_3_count
//         dailyReferralsCount
//       }
//     }
//   }
// `

export const PAIR_CHART = gql`
  query dailyPairStatistics($pairAddress: String!, $skip: Int!) {
    dailyPairStatistics(first: 1000, skip: $skip, orderBy: date, orderDirection: asc, where: { pair: $pairAddress }) {
      id
      date
      dailyVolumeToken0
      dailyVolumeToken1
      dailyVolumeUSD
      reserveUSD
    }
  }
`

export const PAIR_DAY_DATA = gql`
  query dailyPairStatistics($pairAddress: String!, $date: Int!) {
    dailyPairStatistics(first: 1, orderBy: date, orderDirection: desc, where: { pair: $pairAddress, date_lt: $date }) {
      id
      date
      dailyVolumeToken0
      dailyVolumeToken1
      dailyVolumeUSD
      totalSupply
      reserveUSD
    }
  }
`

export const PAIR_DAY_DATA_BULK = (pairs, startTimestamp) => {
  let pairsString = `[`
  pairs.map((pair) => {
    return (pairsString += `"${pair}"`)
  })
  pairsString += ']'
  const queryString = `
    query dailyPairStatistics {
      dailyPairStatistics(first: 1000, orderBy: date, orderDirection: asc, where: { pair_in: ${pairsString}, date_gt: "${startTimestamp}" }) {
        id
        pair {
          id
        }
        date
        dailyVolumeToken0
        dailyVolumeToken1
        dailyVolumeUSD
        totalSupply
        reserveUSD
      }
    }
`
  return gql(queryString)
}

export const GLOBAL_CHART = gql`
  query dailyEnergiswapStatistics($startTime: String!, $skip: Int!) {
    dailyEnergiswapStatistics(
      first: 1000
      skip: $skip
      where: { date_gt: $startTime }
      orderBy: date
      orderDirection: asc
    ) {
      id
      date
      totalVolumeUSD
      dailyVolumeUSD
      dailyVolumeNRG
      totalLiquidityUSD
      totalLiquidityNRG
    }
  }
`

export const GLOBAL_DATA = (block) => {
  const queryString = ` query energiswapFactory {
      energiswapFactory(
       ${block ? `block: { number: ${block}}` : ``}
       id: "1") {
        id
        totalVolumeUSD
        totalVolumeNRG
        untrackedVolumeUSD
        totalLiquidityUSD
        totalLiquidityNRG
        txCount
        pairCount
      }
    }`
  return gql(queryString)
}

// Replaced nested transactions query (not compatible with lightweight indexer).
// Queries mints/burns/swaps directly instead.
export const GLOBAL_MINTS = gql`
  query mints($first: Int!, $windowStart: String!, $windowEnd: String!, $orderDirection: OrderDirection!) {
    mints(
      first: $first
      where: { timestamp_gte: $windowStart, timestamp_lt: $windowEnd }
      orderBy: timestamp
      orderDirection: $orderDirection
    ) {
      transaction { id timestamp }
      pair {
        token0 { id symbol }
        token1 { id symbol }
      }
      to sender liquidity amount0 amount1 amountUSD
    }
  }
`

export const GLOBAL_BURNS = gql`
  query burns($first: Int!, $windowStart: String!, $windowEnd: String!, $orderDirection: OrderDirection!) {
    burns(
      first: $first
      where: { timestamp_gte: $windowStart, timestamp_lt: $windowEnd }
      orderBy: timestamp
      orderDirection: $orderDirection
    ) {
      transaction { id timestamp }
      pair {
        token0 { id symbol }
        token1 { id symbol }
      }
      to sender liquidity amount0 amount1 amountUSD
    }
  }
`

export const GLOBAL_SWAPS = gql`
  query swaps($first: Int!, $windowStart: String!, $windowEnd: String!, $orderDirection: OrderDirection!) {
    swaps(
      first: $first
      where: { timestamp_gte: $windowStart, timestamp_lt: $windowEnd }
      orderBy: timestamp
      orderDirection: $orderDirection
    ) {
      transaction { id timestamp }
      pair {
        token0 { id symbol }
        token1 { id symbol }
      }
      amount0In amount0Out amount1In amount1Out amountUSD to sender
    }
  }
`

export const GLOBAL_DAILY_STATS = gql`
  query dailyEnergiswapStatistics {
    dailyEnergiswapStatistics(first: 16, orderBy: date, orderDirection: desc) {
      date
      dailyVolumeUSD
      dailyVolumeNRG
      totalLiquidityUSD
      totalLiquidityNRG
      txCount
    }
  }
`

// Hourly global stats — used for exact 24h-ago liquidity snapshot
export const HOURLY_GLOBAL_STATS = gql`
  query hourlyEnergiswapStatistics {
    hourlyEnergiswapStatistics(first: 50, orderBy: hourStartUnix, orderDirection: desc) {
      hourStartUnix
      totalLiquidityUSD
    }
  }
`

export const DAILY_TOKEN_STATS = gql`
  query dailyTokenStatistics($dateFrom: String!) {
    dailyTokenStatistics(first: 1000, orderBy: date, orderDirection: desc, where: { date_gt: $dateFrom }) {
      token { id }
      dailyVolumeUSD
      priceUSD
      date
    }
  }
`

export const DAILY_PAIR_STATS = gql`
  query dailyPairStatistics($dateFrom: String!) {
    dailyPairStatistics(first: 1000, orderBy: date, orderDirection: desc, where: { date_gt: $dateFrom }) {
      pair { id }
      dailyVolumeUSD
      date
    }
  }
`

// Paginated hourly pair stats — WHERE filter causes 504, so paginate without it and filter client-side
export const HOURLY_PAIR_STATS_PAGE = gql`
  query hourlyPairStatistics($skip: Int!) {
    hourlyPairStatistics(first: 1000, skip: $skip, orderBy: hourStartUnix, orderDirection: desc) {
      pair { id }
      token0 { id }
      token1 { id }
      hourStartUnix
      hourlyVolumeUSD
    }
  }
`

// Paginated hourly token stats — same pattern; .catch fallback if indexer doesn't support it
export const HOURLY_TOKEN_STATS_PAGE = gql`
  query hourlyTokenStatistics($skip: Int!) {
    hourlyTokenStatistics(first: 1000, skip: $skip, orderBy: hourStartUnix, orderDirection: desc) {
      token { id }
      hourStartUnix
      hourlyVolumeUSD
    }
  }
`

export const ALL_TOKENS = gql`
  query tokens($skip: Int!) {
    tokens(first: 500, skip: $skip) {
      id
      name
      symbol
      totalLiquidity
    }
  }
`

export const TOKEN_SEARCH = gql`
  query tokens($value: String, $id: String) {
    asSymbol: tokens(where: { symbol_contains: $value }, orderBy: totalLiquidity, orderDirection: desc) {
      id
      symbol
      name
      totalLiquidity
    }
    asName: tokens(where: { name_contains: $value }, orderBy: totalLiquidity, orderDirection: desc) {
      id
      symbol
      name
      totalLiquidity
    }
    asAddress: tokens(where: { id: $id }, orderBy: totalLiquidity, orderDirection: desc) {
      id
      symbol
      name
      totalLiquidity
    }
  }
`

export const PAIR_SEARCH = gql`
  query pairs($tokens: [Bytes]!, $id: String) {
    as0: pairs(where: { token0_in: $tokens }) {
      id
      token0 {
        id
        symbol
        name
      }
      token1 {
        id
        symbol
        name
      }
    }
    as1: pairs(where: { token1_in: $tokens }) {
      id
      token0 {
        id
        symbol
        name
      }
      token1 {
        id
        symbol
        name
      }
    }
    asAddress: pairs(where: { id: $id }) {
      id
      token0 {
        id
        symbol
        name
      }
      token1 {
        id
        symbol
        name
      }
    }
  }
`

export const ALL_PAIRS = gql`
  query pairs($skip: Int!) {
    pairs(first: 500, skip: $skip, orderBy: trackedReserveNRG, orderDirection: desc) {
      id
      token0 {
        id
        symbol
        name
      }
      token1 {
        id
        symbol
        name
      }
    }
  }
`

const PairFields = `
  fragment PairFields on Pair {
    id
    txCount
    token0 {
      id
      symbol
      name
      totalLiquidity
      derivedNRG
    }
    token1 {
      id
      symbol
      name
      totalLiquidity
      derivedNRG
    }
    reserve0
    reserve1
    reserveUSD
    totalSupply
    trackedReserveNRG
    reserveNRG
    volumeUSD
    untrackedVolumeUSD
    token0Price
    token1Price
    createdAtTimestamp
  }
`

export const PAIRS_CURRENT = gql`
  query pairs {
    pairs(first: 1000, orderBy: trackedReserveNRG, orderDirection: desc) {
      id
    }
  }
`

export const PAIR_DATA = (pairAddress, block) => {
  const queryString = `
    ${PairFields}
    query pairs {
      pairs(${block ? `block: {number: ${block}}` : ``} where: { id: "${pairAddress}"} ) {
        ...PairFields
      }
    }`
  return gql(queryString)
}

export const PAIRS_BULK = gql`
  ${PairFields}
  query pairs($allPairs: [Bytes]!) {
    pairs(first: 1000, where: { id_in: $allPairs }, orderBy: trackedReserveNRG, orderDirection: desc) {
      ...PairFields
    }
  }
`

export const PAIRS_HISTORICAL_BULK = (block, pairs) => {
  let pairsString = `[`
  pairs.map((pair) => {
    return (pairsString += `"${pair}"`)
  })
  pairsString += ']'
  let queryString = `
  query pairs {
    pairs(first: 200, where: {id_in: ${pairsString}}, block: {number: ${block}}, orderBy: trackedReserveNRG, orderDirection: desc) {
      id
      reserveUSD
      trackedReserveNRG
      volumeUSD
      untrackedVolumeUSD
    }
  }
  `
  return gql(queryString)
}

export const TOKEN_CHART = gql`
  query dailyTokenStatistics($tokenAddr: String!, $skip: Int!) {
    dailyTokenStatistics(first: 1000, skip: $skip, orderBy: date, orderDirection: asc, where: { token: $tokenAddr }) {
      id
      date
      priceUSD
      totalLiquidityToken
      totalLiquidityUSD
      totalLiquidityNRG
      dailyVolumeNRG
      dailyVolumeToken
      dailyVolumeUSD
    }
  }
`

const TokenFields = `
  fragment TokenFields on Token {
    id
    name
    symbol
    derivedNRG
    tradeVolume
    tradeVolumeUSD
    untrackedVolumeUSD
    totalLiquidity
    txCount
  }
`

export const TOKENS_CURRENT = gql`
  ${TokenFields}
  query tokens {
    tokens(first: 200, orderBy: tradeVolumeUSD, orderDirection: desc) {
      ...TokenFields
    }
  }
`

export const TOKENS_DYNAMIC = (block) => {
  const queryString = `
    ${TokenFields}
    query tokens {
      tokens(block: {number: ${block}} first: 200, orderBy: tradeVolumeUSD, orderDirection: desc) {
        ...TokenFields
      }
    }
  `
  return gql(queryString)
}

export const TOKEN_DATA = (tokenAddress, block) => {
  const queryString = `
    ${TokenFields}
    query tokens {
      tokens(${block ? `block : {number: ${block}}` : ``} where: {id:"${tokenAddress}"}) {
        ...TokenFields
      }
      pairs0: pairs(where: {token0: "${tokenAddress}"}, first: 50, orderBy: reserveUSD, orderDirection: desc){
        id
      }
      pairs1: pairs(where: {token1: "${tokenAddress}"}, first: 50, orderBy: reserveUSD, orderDirection: desc){
        id
      }
    }
  `
  return gql(queryString)
}

export const FILTERED_TRANSACTIONS = gql`
  query (
    $allPairs: [Bytes]!
    $first: Int!
    $windowStart: String!
    $windowEnd: String!
    $orderDirection: OrderDirection!
  ) {
    mints(
      first: $first
      where: { pair_in: $allPairs, timestamp_gte: $windowStart, timestamp_lt: $windowEnd }
      orderBy: timestamp
      orderDirection: $orderDirection
    ) {
      transaction {
        id
        timestamp
      }
      pair {
        token0 {
          id
          symbol
        }
        token1 {
          id
          symbol
        }
      }
      to
      sender
      liquidity
      amount0
      amount1
      amountUSD
    }
    burns(
      first: $first
      where: { pair_in: $allPairs, timestamp_gte: $windowStart, timestamp_lt: $windowEnd }
      orderBy: timestamp
      orderDirection: $orderDirection
    ) {
      transaction {
        id
        timestamp
      }
      pair {
        token0 {
          id
          symbol
        }
        token1 {
          id
          symbol
        }
      }
      to
      sender
      liquidity
      amount0
      amount1
      amountUSD
    }
    swaps(
      first: $first
      where: { pair_in: $allPairs, timestamp_gte: $windowStart, timestamp_lt: $windowEnd }
      orderBy: timestamp
      orderDirection: $orderDirection
    ) {
      transaction {
        id
        timestamp
      }
      id
      pair {
        token0 {
          id
          symbol
        }
        token1 {
          id
          symbol
        }
      }
      amount0In
      amount0Out
      amount1In
      amount1Out
      amountUSD
      to
      sender
    }
  }
`
